module.exports = __webpack_public_path__ + "static/media/img-feature-slider-2.24bf70ce.png";